/**
 * Model for FSS object
 */
export class Fss {
  /**
   * the database id of the fss
   */
  fssId: string;

  /**
   * the name of the fss
   */
  name: string;

  /**
   * the onsite number of the fss
   */
  onSiteNumber: string;

  static parse(data: any): Fss {
    return Object.assign(new Fss(), {
      fssId: data.fssId,
      name: data.name,
      onSiteNumber: data.OnSiteNumber
    });
  }
}
